module.exports = __webpack_public_path__ + "static/media/WelcomeBackground.769917ae.png";